class DetailsDisclosure extends HTMLElement {
  connectedCallback() {
    if (this._detailsDisclosureInit) return;
    this._detailsDisclosureInit = true;

    this.mainDetailsToggle = this.querySelector('details');
    if (!this.mainDetailsToggle) {
      return;
    }

    const summary = this.mainDetailsToggle.querySelector('summary');
    this.content = summary ? summary.nextElementSibling : null;
    if (!this.content) {
      return;
    }

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    if (!this.mainDetailsToggle) return;
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.mainDetailsToggle || !this.content) return;
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    if (!this.mainDetailsToggle) return;
    const summary = this.mainDetailsToggle.querySelector('summary');
    this.mainDetailsToggle.removeAttribute('open');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  connectedCallback() {
    super.connectedCallback();
    if (this._headerMenuInit) return;
    this._headerMenuInit = true;
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.mainDetailsToggle) return;
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
